import { API_AUTH } from "../.././common";

const DsCapPheDuyetApi = {
  list: ({ sSearch, iPageIndex, iPageSize }) =>
    API_AUTH.get(
      `cappheduyet/danhsach?sSearch=${sSearch}&iPageIndex=${iPageIndex}&iPageSize=${iPageSize}`,
      {}
    ),
  addOrUpdate: (params) => API_AUTH.post("cappheduyet/addorupdate", params),
  deleteCap: ({ iCap }) => API_AUTH.post("cappheduyet/delete?iCap=" + iCap),
  getQuyenChoDuyetByUserName: ({ UserName }) => API_AUTH.get("quyentaochoduyet/GetQuyenTaoChoDuyetByUserName?UserName=" + UserName),
  saveQuyenChoDuyetByUserName: (params) => API_AUTH.post("quyentaochoduyet/SaveQuyenChoDuyetByUserName", params),
  getLichSuPheDuyet: ({ ChoVayID }) => API_AUTH.get("quytrinhpheduyet/lich-su-duyet?ChoVayID=" + ChoVayID),

};

export default DsCapPheDuyetApi;
